/**
 * fetch for the consent-capture SDK. Applicant auth is the applicant_auth cookie (DLC-1725), so every
 * request to reznor must carry credentials — the same as the axios instances in V2/Services.
 */
export const credentialedFetch: typeof fetch = (input, init) =>
  fetch(input, { ...init, credentials: 'include' });
